export default __webpack_public_path__ + "static/media/af-logo.620ef9cc.svg";